import React from "react";
import css from './footerRecordFloor.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";
import useMyStores from "../../hooks/useMyStores";

const Index = ({className}) => {

    const {app: appStore} = useMyStores()

    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={css.floorList}>
                    <div className={css.floor1}>
                        © {appStore.recordTime} {appStore.app?.domain} 版权所有@
                        {appStore.app?.websiteName} {appStore.app?.platformName}
                    </div>
                    {
                        appStore.contact?.show &&
                        <div
                            className={css.floor2}
                        >
                            持有人 {appStore.contact?.name}
                        </div>
                    }
                    <div
                        className={css.floor3}
                        onClick={() => {
                            //工信部
                            window.open(appStore.recordUrl);
                        }}
                    >
                        {appStore.website?.recordNumber}
                    </div>
                    <div id="glx-ssl-cert" style={{
                        marginTop: "12px"
                    }}/>
                    {/*{*/}
                    {/*    appStore.website?.policeRecordNumber &&*/}
                    {/*    <div className={css.floor3}>*/}
                    {/*        {appStore.website?.policeRecordNumber}*/}
                    {/*    </div>*/}
                    {/*}*/}
                </div>
            </div>
        </div>
    )
}

export default observer(Index)